import { Icon, Tag, Text } from "@blueprintjs/core"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import CustomStaticSelector from "components/Atoms/CustomStaticSelector"
import CustomTag from "components/Atoms/CustomTag"
import AppToaster from "utils/AppToaster"
import { CHANGE_ORDER_SEQUENCE } from "store/dispatch.redux"
import classNames from "utils/classNames"

const OrderSerial = ({ order, items, index }) => {
  const dispatch = useDispatch()
  const custom = useSelector(
    (state: any) => state.dispatch.orderSequenceCustomized
  )
  //
  let totalQuantity = 0,
    pickedQuantity = 0
  for (const item of order?.orderItems ?? []) {
    totalQuantity += item?.quantity
    // Only add to picked quantity if the OrderItem is selected
    if (item?.isSelected) {
      pickedQuantity +=
        item?.newQuantity ?? item?.requiredQuantity ?? item?.quantity
    }
  }

  return (
    <div className={classNames("vt-order p-3 w-full")}>
      <Icon icon="th-list" />
      <CustomStaticSelector
        items={items}
        onChange={(_, value) => {
          if (custom) {
            dispatch({
              type: CHANGE_ORDER_SEQUENCE,
              payload: { newIndex: value?.id, oldIndex: index, order },
            })
            return
          }

          AppToaster.show({
            message: "Changing order will disable default route optimization",
            intent: "warning",
            icon: "warning-sign",
            action: {
              text: "Change",
              onClick() {
                dispatch({
                  type: CHANGE_ORDER_SEQUENCE,
                  payload: { newIndex: value?.id, oldIndex: index, order },
                })
              },
            },
          })
        }}
      >
        {value => {
          return (
            <Tag
              className="ml-3 d-center"
              interactive={true}
              minimal
              intent="primary"
            >
              {value?.name ?? index + 1}{" "}
              <Icon icon="chevron-down" iconSize={8} />
            </Tag>
          )
        }}
      </CustomStaticSelector>
      <section>
        <p>
          {order?.user?.fullName}{" "}
          <CustomTag minimal small round>
            {pickedQuantity} / {totalQuantity}{" "}
            <span className="text-xs vt-muted">Units</span>
          </CustomTag>
          {order?.crateCount > 0 && (
            <CustomTag minimal small round intent="primary">
              {order.crateCount}{" "}
              <span className="text-xs vt-muted">Crates</span>
            </CustomTag>
          )}
        </p>
        <Text className="vt-address-text" ellipsize={true}>
          {order?.shippingAddress?.village ?? "Na"}
        </Text>
      </section>
    </div>
  )
}

export default OrderSerial
